export const DEVICE_TYPE_MOBILE = 'DEVICE_TYPE_MOBILE';
export const DEVICE_TYPE_PAD = 'DEVICE_TYPE_PAD';
export const DEVICE_TYPE_DESKTOP = 'DEVICE_TYPE_DESKTOP';
